import { useState } from 'react';

export function usePrevious<T>(value: T): T | undefined;
export function usePrevious<T, U>(value: T, defaultValue: U): T | U;
export function usePrevious<T, U>(value: T, defaultValue?: U) {
  const [current, setCurrent] = useState<T>(value);
  const [previous, setPrevious] = useState<T | U | undefined>(defaultValue);

  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}
